import { Provider } from 'jotai';
import { DevTools } from 'jotai-devtools';
import type { ReactNode } from 'react';

import 'jotai-devtools/styles.css';

import { jotaiStore } from '@/shared/store/store';

interface JotaiProviderProps {
  readonly children: ReactNode;
}

/**
 * Provider global do Jotai.
 *
 * Em desenvolvimento, inclui o painel de DevTools do Jotai que exibe
 * todos os átomos ativos e seus valores em tempo real.
 *
 * Para átomos escopados de features, use `<Provider>` dentro do
 * provider da feature correspondente.
 */
export function JotaiProvider({ children }: JotaiProviderProps) {
  return (
    <Provider store={jotaiStore}>
      {import.meta.env.DEV && <DevTools store={jotaiStore} />}
      {children}
    </Provider>
  );
}
